/**
 * Ruta `/registrar` (US2, T033): enrolamiento del dispositivo.
 *
 * Último paso de la activación: crea la clave del teléfono, la registra en
 * `POST /activation/{token}/enroll` (firmado, sin `id=`) y, con el 201, borra el token de
 * `sessionStorage` y pasa a `/listo`. Un `428` devuelve al aviso de privacidad del mismo enlace.
 */
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback, useState } from 'react';

import { clearActivationToken, getActivationToken } from '../features/activation/activation-store';
import { EnrollScreen } from '../features/activation/enroll';
import { InvalidLinkScreen } from '../features/activation/link-invalid';
import { t } from '../i18n';

export function EnrollRoute() {
  const navigate = useNavigate();
  const [token] = useState(() => getActivationToken());
  const [gone, setGone] = useState(false);

  const onEnrolled = useCallback(() => {
    clearActivationToken();
    void navigate({ to: '/listo', replace: true });
  }, [navigate]);

  const onPrivacyRequired = useCallback(() => {
    if (token !== null) {
      void navigate({
        to: '/activar/$token',
        params: { token },
        search: { paso: 'privacidad' },
        replace: true,
      });
    }
  }, [navigate, token]);

  // 005 · QA-6: sin el documento verificado, de vuelta al enlace (pide los 4 dígitos).
  const onVerificationRequired = useCallback(() => {
    if (token !== null) {
      void navigate({ to: '/activar/$token', params: { token }, replace: true });
    }
  }, [navigate, token]);

  if (token === null) {
    return <InvalidLinkScreen description={t('activation.invalid.noToken')} />;
  }
  if (gone) {
    return <InvalidLinkScreen />;
  }

  return (
    <EnrollScreen
      token={token}
      onEnrolled={onEnrolled}
      onGone={() => setGone(true)}
      onPrivacyRequired={onPrivacyRequired}
      onVerificationRequired={onVerificationRequired}
    />
  );
}

export const Route = createFileRoute('/registrar')({
  component: EnrollRoute,
});
